import { FunctionComponent, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Grid } from '@material-ui/core'

import ContainerPage from 'shared/components/ContainerPage'

import truckDriver2 from 'shared/assets/images/truck-driver.png'

import {
  Container,
  ContainerBeneficios,
  ContainerFooter,
  Footer,
  PaddingText,
  Text,
  TextFooter,
  Title,
} from './styles'
import { BsTruck } from 'react-icons/bs'
import { AiOutlineCreditCard } from 'react-icons/ai'
import { RiMoneyDollarCircleLine } from 'react-icons/ri'
import { FaHandsHelping } from 'react-icons/fa'
import Button from 'shared/components/Button'
import { colors } from 'shared/styles/colors'
import Beneficio from './components/Beneficio'
import AppTmovFrotista from './components/AppTmovFrotista'
import Requisitos from './components/Requisitos'
import { useOnboarding } from 'modules/pagamentos/hooks/useOnboarding'
import ModalParceiros from './components/ModalParceiros'

type TLocationState = {
  quarteirizacao?: boolean
}

const TmovPayInstructions: FunctionComponent = () => {
  const { clear } = useOnboarding()
  const { state } = useLocation<TLocationState>()
  const [modalParceiros, setModalParceiros] = useState(
    state?.quarteirizacao ?? false,
  )
  const [openDrawerAppTmovFrotista, setOpenDrawerAppTmovFrotista] =
    useState(false)
  const [openModalRequisitos, setOpenModalRequisitos] = useState(false)

  useEffect(() => {
    clear()
  }, [])

  const handleModalRequisitos = () => {
    setOpenModalRequisitos(!openModalRequisitos)
  }

  return (
    <ContainerPage breadCrumb="Tmov Pay" showFooterScaffold={false}>
      <Container>
        <Grid container>
          <Grid item xl={4} lg={6} md={12} xs={12}>
            <img
              src={truckDriver2}
              style={{
                marginLeft: -40,
                marginTop: -40,
                width: '100%',
                height: '100%',
              }}
            />
          </Grid>
          <Grid item xl={6} lg={6} md={12} xs={12}>
            <PaddingText>
              <Title>Bem vindo ao Tmov Pay</Title>
              <Text>
                Para aproveitar todas as vantagens é necessário que você
                complete seu cadastro
              </Text>
              <ContainerBeneficios>
                <Grid container>
                  <Grid item xl={6} lg={6} md={6} xs={6}>
                    <Beneficio
                      title="Pagamentos de frete"
                      text="Receba adiantado até 70% do valor dos fretes
              da Tmov."
                      icon={AiOutlineCreditCard}
                    />
                    <Beneficio
                      title="Praticidade"
                      text="Defina parâmetros para realizar pagamentos automáticos
                para seus motoristas"
                      icon={FaHandsHelping}
                    />
                  </Grid>
                  <Grid item xl={6} lg={6} md={6} xs={6}>
                    <Beneficio
                      title="Conta digital"
                      text="Realize transferências, pague boletos e muito mais!"
                      icon={RiMoneyDollarCircleLine}
                    />
                    <Beneficio
                      title="Mais vantagens"
                      text="Gerencie sua frota de forma simples e ágil e
                aproveite muito mais vantagens!"
                      icon={BsTruck}
                    />
                  </Grid>
                </Grid>
              </ContainerBeneficios>
            </PaddingText>
            <Grid item xl={12} lg={12} md={12} xs={12}>
              <ContainerFooter>
                <Button color={colors.green} onClick={handleModalRequisitos}>
                  Completar cadastro
                </Button>
                <Footer>
                  <TextFooter>
                    Se preferir, complete seu cadastro pelo
                  </TextFooter>
                  <Button
                    style={{ width: '121px' }}
                    size="large"
                    fontColor={colors.green}
                    color={'transparent'}
                    onClick={() => setOpenDrawerAppTmovFrotista(true)}
                  >
                    App Tmov Frotista
                  </Button>
                </Footer>
              </ContainerFooter>
            </Grid>
          </Grid>
        </Grid>
      </Container>
      <AppTmovFrotista
        open={openDrawerAppTmovFrotista}
        setOpen={setOpenDrawerAppTmovFrotista}
      />
      <Requisitos
        openModal={openModalRequisitos}
        setOpenModal={handleModalRequisitos}
      />
      <ModalParceiros
        open={modalParceiros}
        onClose={() => setModalParceiros(false)}
      />
    </ContainerPage>
  )
}

export default TmovPayInstructions
